import { render, staticRenderFns } from "./BattlesFilterSortCases.vue?vue&type=template&id=770d0d4c&scoped=true"
import script from "./BattlesFilterSortCases.vue?vue&type=script&lang=js"
export * from "./BattlesFilterSortCases.vue?vue&type=script&lang=js"
import style0 from "./BattlesFilterSortCases.vue?vue&type=style&index=0&id=770d0d4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "770d0d4c",
  null
  
)

export default component.exports